import React from 'react';
import AvailabilityCalendar from './AvailabilityCalendar';

const AdminAvailability = () => {
  return <AvailabilityCalendar isAdmin={true} />;
};

export default AdminAvailability;
